export default __webpack_public_path__ + "static/assets/0eab05a301530a7811d6331241fbfb49.png";